import type { ClaimState } from '../types/catalog'
import { CLAIM_LABELS } from '../lib/catalog'

export default function ClaimStateBadge({ state }: { state: ClaimState | null }) {
  const style = state === 'conflicting' ? 'border-amber-200 bg-amber-50 text-amber-950' : state === 'source_verified' || state === 'expert_reviewed' ? 'border-notice-border bg-notice text-notice-ink' : 'border-line bg-paper text-muted'
  return <span className={`inline-flex rounded-md border px-2 py-1 text-xs font-medium leading-5 ${style}`}>{state ? CLAIM_LABELS[state] : 'Not yet verified'}</span>
}
